import { useEffect, useState } from "react";
import {
  getAllElectionCandidates,
  voteElectionCandidate,
} from "../../../../redux/action/election";
import "./index.scss";
import { handleRequestErrors } from "../../../../shared/utils";
import { Button } from "react-bootstrap";
import { LoadingItem } from "../../../../shared/components/loading";
import { toast } from "react-toastify";
import { DotLoader } from "react-spinners";

interface Candidate {
  electCandidateUniqueId: string;
  electionCandidatePhotoPassport: string;
  matricNumber: string;
  fullName: string;
  level: string;
  session: string;
  electionPosition: string;
  electionType: string;
}

interface Election {
  positionName: string;
  candidates: Candidate[];
}

const VotingPage = ({electionType}: any) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [data, setData] = useState<Election[]>([]);
  const [selectedCandidates, setSelectedCandidates] = useState<{
    [position: string]: string;
  }>({});
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [hasVoted, setHasVoted] = useState(false);

  let loggedAccountInfo: any = localStorage.getItem("stuXAuth") || "{}";
  loggedAccountInfo = JSON.parse(loggedAccountInfo);
  const studentInfo = loggedAccountInfo?.profile || {};

  const fetchCandidates = async () => {
    if (!electionType) {
      setIsLoading(false);
      return;
    }
    try {
      setIsLoading(true);
      const response = await getAllElectionCandidates(electionType);
      if (response.status === 200) {
        console.log(response.data)
        setData(response?.data || []);
      }
    } catch (error) {
      handleRequestErrors(error);
    } finally {
      setIsLoading(false);
    }
  };



  useEffect(() => {
    fetchCandidates();
  }, [electionType]);

  const handleCandidateSelection = (candidate: Candidate) => {
    setSelectedCandidates((prevSelected) => ({
      ...prevSelected,
      [candidate.electionPosition]:
        prevSelected[candidate.electionPosition] ===
        candidate.electCandidateUniqueId
          ? ""
          : candidate.electCandidateUniqueId,
    }));
  };

  const numberOfPositions =
    data.map((data: any) => data.positionName).length || 0;

  const handleSubmit = async () => {
    setError(null);
    setHasVoted(false);
    const selections = Object.entries(selectedCandidates).filter(
      ([, candidateId]) => candidateId
    );
    if (selections.length === 0) {
      toast.error("Please select at least one candidate to vote.");
      return;
    }
    if (selections.length < numberOfPositions) {
      toast.error("Please select one candidate in every category.");
      return;
    }

    setIsSubmitting(true);
    const studentUniqueId = studentInfo?.studentUniqueId || "";
    const payload = selections.map(([position, candidateId]) => ({
      electionType,
      studentUniqueId,
      electionPosition: position,
      electionCandidateUniqueId: candidateId,
    }));

    try {
      const response = await voteElectionCandidate(payload);
      if (response.status === 200) {
        setSuccess(true);
      }
      if (response.response.status === 400) {
        setError(response?.response?.data);
        setHasVoted(true);
      }
    } catch (error) {
      setError(handleRequestErrors(error));
      setHasVoted(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) {
    return <LoadingItem />;
  }

  return (
    <>
      {!success && !hasVoted && (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <div className="voting-page-container">
            <div className="voting-page">
              <p className="notice">
                Ready to vote? Please pick at least one candidate in each
                category, then click the SUBMIT button to SUBMIT your votes!
              </p>
              {data.map((election, index) => (
                <div key={index} className="election-section">
                  <h2 className="cand-position">{election.positionName}</h2>
                  <div className="candidate-container">
                    {election.candidates.map((candidate) => (
                      <div
                        className="candidate"
                        key={candidate.electCandidateUniqueId}
                      >
                        <img
                          className="cand-img"
                          src={candidate.electionCandidatePhotoPassport}
                          alt={`Photo of ${candidate.fullName}`}
                        />
                        <p className="cand-name">{candidate.fullName}</p>
                        <Button
                          className="vote-btn"
                          disabled={
                            selectedCandidates[candidate.electionPosition] ===
                            candidate.electCandidateUniqueId
                          }
                          style={{
                            backgroundColor:
                              selectedCandidates[candidate.electionPosition] ===
                              candidate.electCandidateUniqueId
                                ? "#28a745"
                                : "#173a77",
                          }}
                          onClick={() => handleCandidateSelection(candidate)}
                        >
                          {selectedCandidates[candidate.electionPosition] ===
                          candidate.electCandidateUniqueId
                            ? "Selected"
                            : "Vote"}
                        </Button>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
              <div className="submit-container">
                <Button style={{padding: "20px"}} className="paid-btn submit-btn" type="submit">
                  {isSubmitting ? (
                    <DotLoader
                      color="white"
                      loading={isSubmitting}
                      size={30}
                      aria-label="Submitting"
                    />
                  ) : (
                    "Submit Selections"
                  )}
                </Button>
              </div>
            </div>
          </div>
        </form>
      )}
      <div className="message-container">
        {error && !success && <p className="error-message">{error}</p>}
        {success && (
          <p className="success-message">
            Your vote has been successfully submitted.
          </p>
        )}
      </div>
    </>
  );
};

export default VotingPage;
